import React from "react";
import { message, Form } from "antd";
import styled from "styled-components";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";

import colors from "constants/palette";
import Button from "components/buttons/Button";
import Input from "components/inputs/Input";
import NumberInput from "components/inputs/NumberInput";
import Select from "components/inputs/Select";
import Loading from "components/App/Loading";
import { Header } from "components/App/styled";

// props::
// 1 up parent =>product,setProduct,reload, setReload,
// 2 up parent => products, list, setList
export default function App({
  product,
  setProduct,
  reload,
  setReload,
  products,
  list,
  setList,
}) {
  const [form] = Form.useForm();
  console.log(list);
  React.useEffect(() => {
    setReload(false);
  }, [list.length, list, reload, setReload]);

  console.log(product);
  function onSubmit({ title, amount, description }) {
    if (title) {
      if (list.some((item) => item.title === title)) {
        message.error("کالای مورد نظر در فاکتور وجود دارد");
        return false;
      } else {
        setList((e) => [
          ...e,
          { title, amount, description, price: product.price },
        ]);
        form.resetFields();
        setProduct([]);
      }
    } else {
      message.error("لطفا نام کالای مورد نظر را انتخاب کنید");
    }
  }

  function deleteItem(index) {
    var newList = list;
    newList.splice(index, 1);
    setReload(true);
    setList(newList);
    message.success("با موفقیت حذف شد");
  }

  const total = list
    .map((item) => ({ amount: item.amount, price: item.price }))
    .reduce((a, b) => Number(a) + Number(b.amount) * Number(b.price), 0);

  if (!products) {
    return <Loading />;
  }
  return (
    <Container>
      <Col>
        <Header>لیست سفارش :</Header>
        <Form
          form={form}
          layout="vertical"
          style={{ direction: "rtl" }}
          //   requiredMark={requiredMark}
          onFinish={onSubmit}
        >
          <Label>نام کالا :</Label>
          <Form.Item
            name="title"
            rules={[
              {
                required: true,
                message: "لطفا نام کالا را وارد کنید!",
              },
            ]}
            initialValue={false}
          >
            <Select
              borderradius="0"
              list={products}
              showSearch
              placeholder="جستجو"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
              onChange={(value, data) => setProduct(products[data.key])}
            />
          </Form.Item>
          {product.title && (
            <>
              <Detail>
                <span>قیمت </span>
                <span>{product.price}</span>
              </Detail>
              <Detail color={product.stock === 0 ? colors.red : "initial"}>
                <span>موجودی انبار </span>
                <span>{product.stock}</span>
              </Detail>
            </>
          )}
          <Label>تعداد :</Label>
          <Form.Item
            name="amount"
            rules={[
              {
                required: true,
                message: "لطفا تعداد را وارد کنید!",
              },
            ]}
          >
            <NumberInput min={1} style={{ width: "100%" }} />
          </Form.Item>

          {/* <AntInput.TextArea rows={5} /> */}
          <Label>توضیحات :</Label>
          <Form.Item name="description">
            <Input size="large" placeholder="" />
          </Form.Item>
          <Button
            onClick={() => form.submit()}
            style={{ width: "100%", marginTop: 16 }}
          >
            <PlusOutlined style={{ marginLeft: 12 }} /> اضافه کردن
          </Button>
        </Form>
      </Col>

      <ColLeft>
        <Header>پیش فاکتور</Header>
        <Table>
          <TableRow>
            <span className="cell title-row">نام کالا</span>
            <span className="cell" style={{ borderLeft: "1px solid #3a4041" }}>
              تعداد
            </span>
            <span className="cell" style={{ maxWidth: 76 }}>
              حذف
            </span>
          </TableRow>
          {list?.length
            ? list.map((item, index) => (
                <TableRow key={index}>
                  <span className="cell title-row">{item.title}</span>
                  <span
                    className="cell"
                    style={{ borderLeft: "1px solid #3a4041" }}
                  >
                    {item.amount}
                  </span>
                  <span className="cell" style={{ maxWidth: 76 }}>
                    <DeleteButton onClick={() => deleteItem(index)} />
                  </span>
                </TableRow>
              ))
            : null}
        </Table>
        <span style={{ marginTop: 18 }}>مجموع : {total}</span>
      </ColLeft>
    </Container>
  );
}
const Container = styled.div`
  display: flex;
  margin-bottom: 64px;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;
const Col = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;

  @media (max-width: 480px) {
    margin-top: 36px;
  }
`;
const ColLeft = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
  margin-right: 64px;

  width: calc(100% - 300px);

  @media (max-width: 480px) {
    margin-top: 36px;
    margin-right: 0;
    width: 100%;
  }
`;

const Label = styled.label`
  margin-bottom: 10px;
  display: block;
  color: ${colors.dark};
`;
const Table = styled.div`
  border: 1px solid ${colors.primary};
  border-radius: 3px;
  overflow-x: auto;
  border-bottom: none;
`;
const TableRow = styled.div`
  border-bottom: 1px solid ${colors.primary};
  display: flex;
  & .cell {
    width: 40%;
    text-align: center;
    padding: 3px 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  & .title-row {
    border-left: 1px solid #3a4041;
    width: 70%;
    display: block;
    text-align: start;
    display: flex;
    align-items: center;
  }
`;
const Detail = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;

  color: ${({ color }) => (color ? color : colors.primary)};
`;
const DeleteButton = styled(DeleteOutlined)`
  color: ${colors.red};
  cursor: pointer;
  text-align: center;
  font-size: 17px;
  position: relative;
  top: 2px;
`;
